import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const parkingAreaStyles = makeStyles((theme) => ({
    root: {
        border: "2px solid white",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "white",
        padding: "16px",
        height: `calc(100vh - 147px)`,
        overflow: "hidden",
        margin: "16px"
    },
    content: {
        textAlign: "center"
    },
    button: {
        borderRadius: theme.palette.borderRadius,
        boxShadow: "none",
        fontSize:"0.875rem"
    },
    filterButton: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        padding: "12px",
        marginLeft: "16px"
    },
    addParkingAreaDialog: {
        "& .MuiDialog-paper": {
            borderRadius: theme.palette.borderRadius,
            padding: "0px",
            width: "320px",
        },
    },
    addParkingAreaDialogHeader: {
        padding: "16px 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #E4E8EE"
    },
    addParkingAreaDialogHeaderTitle: {
        fontFamily: FontFamilySwitch().extraBold,
        fontSize:"1rem",
        color: "#091B29"
    },
    addParkingAreaDialogCloseButton: {
        padding: "0px"
    },
    addParkingAreaDialogBody: {
        padding: "24px",
        overflowY: "overlay"
    },
    addParkingAreaDialogFooter: {
        display: "flex",
        columnGap: "12px",
        padding: "24px",
    },
    addParkingAreaDialogFooterButton: {
        borderRadius: theme.palette.borderRadius,
        height: "45px",
        border: "1px solid #5078E1",
        boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.08)",
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold,
        color: "white"
    },
    addParkingAreaDialogFooterCloseButton: {
        borderRadius: theme.palette.borderRadius,
        height: "45px",
        border: "1px solid #5078E1",
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold,
        color: "#5078E1",
        backgroundColor: "white",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#E4E8EE ",
        },
    },
    addParkingAreaDialogFieldLabel: {
        color: "#98A0AC",
        fontFamily: FontFamilySwitch().semiBold,
        fontSize:"0.75rem",
        marginBottom: "8px",
    },
    addParkingAreaDialogButtonContainer: {
        display: "flex",
        rowGap: "8px",
        columnGap: "8px",
    },
    addParkingAreaDialogButtonSelected: {
        borderRadius: theme.palette.borderRadius,
        height: "4opx",
        border: "1px solid #5078E1",
        backgroundColor: "#5078E1",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#5078E1 ",
        },
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold,
        color: "white",
    },
    addParkingAreaDialogButtonUnSelected: {
        borderRadius: theme.palette.borderRadius,
        height: "40px",
        border: "1px solid #E4E8EE",
        backgroundColor: "white",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#E4E8EE ",
        },
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
        color: "#98A0AC",
    },
}));